var path = 'src/app/patients/diagnoses/diagnoses.html';
var html = "<h1 class=page-header>Comorbidities</h1> <div patient-diagnoses-component patient=patient></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/diagnoses/diagnoses.html
 ** module id = 437
 ** module chunks = 0
 **/